import _classCallCheck from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _assertThisInitialized from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/createSuper";
import { ChatBase } from './chat-base.js';
var defaultOptions = {};
export var Chat = /*#__PURE__*/function (_ChatBase) {
  _inherits(Chat, _ChatBase);

  var _super = _createSuper(Chat);

  function Chat(props) {
    var _this;

    _classCallCheck(this, Chat);

    _this = _super.call(this, props);

    _this.init(props, _assertThisInitialized(_this), defaultOptions);

    return _this;
  }

  return Chat;
}(ChatBase);